'use client'
import LoginView from '@/app/components/LoginView'

export default function Welcome() {
	return <LoginView />
}
